import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ArticleCards() {
  const { t } = useTranslation();

  const featuredArticles = [
    {
      title: "OOPBUY Spreadsheet Deutsch erklärt",
      excerpt: "In diesem umfassenden Guide erfährst du alles über die Nutzung des OOPBUY Spreadsheets. Von den Grundlagen bis zu fortgeschrittenen Tipps — komplett auf Deutsch erklärt und für Anfänger optimiert.",
      link: "/oopbuy-spreadsheet-deutsch-erklaert",
      tag: t("article_category_tag"),
      date: "15. Juli 2026",
      readTime: "12 Min",
      isHero: true,
      img: "https://readdy.ai/api/search-image?query=Fashion%20model%20wearing%20modern%20streetwear%20outfit%20in%20natural%20urban%20setting%2C%20soft%20golden%20hour%20light%2C%20editorial%20fashion%20photography%2C%20clean%20minimalist%20composition%2C%20warm%20neutral%20tones%2C%20sophisticated%20style%2C%20natural%20pose%2C%20professional%20quality%2C%20vertical%20portrait%20orientation%2C%20elegant%20aesthetic&width=800&height=1000&seq=article-hero-card-v2&orientation=portrait",
    },
    {
      title: "OOPBUY Einkaufsguide 2026",
      excerpt: "Schritt für Schritt erklärt: So nutzt du das OOPBUY Spreadsheet für sichere und effiziente Einkäufe. Der ultimative Einkaufsguide.",
      link: "/einkaufsguide",
      tag: "Guide",
      date: "14. Juli 2026",
      readTime: "14 Min",
      isHero: false,
      img: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20white%20desk%20setup%20with%20fashion%20moodboard%20and%20product%20catalog%20spread%20out%2C%20natural%20morning%20light%2C%20organized%20creative%20workspace%2C%20editorial%20photography%20style%2C%20sage%20green%20and%20warm%20beige%20color%20palette&width=800&height=500&seq=article-wide-einkaufsguide-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Sneaker Spreadsheet Guide",
      excerpt: "Entdecke die besten Sneaker im OOPBUY Spreadsheet. Trends, Preise und Tipps für Sneaker-Fans — komplett auf Deutsch.",
      link: "/oopbuy-sneaker-spreadsheet-guide",
      tag: "Sneaker",
      date: "14. Juli 2026",
      readTime: "11 Min",
      isHero: false,
      img: "https://readdy.ai/api/search-image?query=Colorful%20premium%20sneaker%20collection%20on%20white%20floating%20shelves%2C%20soft%20diffused%20studio%20lighting%2C%20clean%20editorial%20product%20photography%2C%20fresh%20spring%20aesthetic%20with%20sage%20green%20accents%2C%20organized%20sneaker%20display%2C%20bright%20airy%20composition&width=800&height=500&seq=article-wide-sneaker-v2&orientation=landscape",
    },
  ];

  const moreArticles = [
    {
      title: "So funktioniert das OOPBUY Spreadsheet",
      excerpt: "Eine Schritt-für-Schritt Anleitung zur effizienten Nutzung des OOPBUY Spreadsheets. Lerne, wie du Produkte schneller findest.",
      link: "/oopbuy-spreadsheet-deutsch-erklaert",
      tag: "Anleitung",
      date: "14. Juli 2026",
      readTime: "8 Min",
      img: "https://readdy.ai/api/search-image?query=Clean%20laptop%20screen%20displaying%20organized%20spreadsheet%20with%20fashion%20product%20data%2C%20modern%20workspace%20with%20natural%20light%2C%20minimalist%20desk%20setup%2C%20warm%20wood%20accents%2C%20editorial%20productivity%20photography%2C%20sage%20and%20cream%20tones&width=600&height=400&seq=article-more-workspace-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Sicherheit & Datenschutz",
      excerpt: "Alles Wichtige zu Sicherheit, Datenschutz und verifizierten Verkäufern beim Einkauf mit OOPBUY. Deine Sicherheit steht an erster Stelle.",
      link: "/oopbuy-sicherheit-datenschutz-guide",
      tag: "Sicherheit",
      date: "13. Juli 2026",
      readTime: "10 Min",
      img: "https://readdy.ai/api/search-image?query=Modern%20secure%20online%20shopping%20concept%20with%20laptop%20showing%20shield%20icon%20and%20product%20catalog%2C%20clean%20white%20desk%2C%20soft%20natural%20light%2C%20professional%20workspace%2C%20calm%20atmosphere%2C%20sage%20green%20accents%2C%20editorial%20technology%20photography&width=600&height=400&seq=article-more-security-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Streetwear & Hoodie Guide",
      excerpt: "Die besten Hoodies und Streetwear-Pieces im OOPBUY Spreadsheet entdecken. Trends, Marken und Styling-Tipps für 2026.",
      link: "/oopbuy-streetwear-hoodie-guide",
      tag: "Streetwear",
      date: "10. Juli 2026",
      readTime: "10 Min",
      img: "https://readdy.ai/api/search-image?query=Trendy%20streetwear%20flat%20lay%20with%20oversized%20hoodies%20on%20clean%20concrete%2C%20natural%20urban%20lighting%2C%20modern%20street%20fashion%20editorial%2C%20warm%20terracotta%20and%20cream%20tones%2C%20minimalist%20urban%20aesthetic&width=600&height=400&seq=article-more-streetwear-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Versand nach Deutschland",
      excerpt: "Alles zu Versandmethoden, Lieferzeiten, Zoll und Tracking. Der komplette Versand-Guide für deutsche OOPBUY Nutzer.",
      link: "/oopbuy-versand-deutschland-guide",
      tag: "Versand",
      date: "12. Juli 2026",
      readTime: "9 Min",
      img: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20shipping%20parcels%20and%20fashion%20items%20on%20light%20wood%20table%2C%20natural%20daylight%2C%20modern%20ecommerce%20aesthetic%2C%20organized%20package%20display%2C%20warm%20beige%20tones%2C%20editorial%20product%20photography&width=600&height=400&seq=article-more-shipping-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Anfänger Guide",
      excerpt: "Von Null auf Profi: Alles was du als OOPBUY Anfänger wissen musst. Der freundliche Einstieg in die Spreadsheet-Nutzung.",
      link: "/oopbuy-spreadsheet-anfaenger-guide",
      tag: "Anfänger",
      date: "11. Juli 2026",
      readTime: "13 Min",
      img: "https://readdy.ai/api/search-image?query=Fresh%20clean%20desk%20with%20open%20notebook%20showing%20organized%20notes%2C%20morning%20sunlight%2C%20beginner%20workspace%2C%20minimalist%20welcoming%20atmosphere%2C%20soft%20sage%20green%20stationery%2C%20calm%20organized%20composition&width=600&height=400&seq=article-more-beginner-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Kategorien im Überblick",
      excerpt: "Entdecke alle 14 Produktkategorien des OOPBUY Spreadsheets. Der ultimative Kategorie-Überblick für Einsteiger und Profis.",
      link: "/oopbuy-spreadsheet-deutsch-erklaert",
      tag: "Kategorien",
      date: "10. Juli 2026",
      readTime: "7 Min",
      img: "https://readdy.ai/api/search-image?query=Colorful%20labeled%20product%20category%20cards%20spread%20across%20light%20wooden%20desk%2C%20organized%20catalog%20concept%2C%20soft%20daylight%2C%20clean%20modern%20aesthetic%2C%20pastel%20accents%2C%20editorial%20stationery%20photography%2C%20bright%20airy%20atmosphere&width=600&height=400&seq=article-more-categories-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Spreadsheet Guide 2026",
      excerpt: "Der aktuellste Guide mit allen neuen Features, Kategorien und Optimierungen. Bleib auf dem neuesten Stand.",
      link: "/oopbuy-spreadsheet-deutsch-erklaert",
      tag: "Update",
      date: "9. Juli 2026",
      readTime: "8 Min",
      img: "https://readdy.ai/api/search-image?query=Modern%20digital%20calendar%20displaying%202026%20on%20white%20screen%2C%20fashion%20items%20nearby%2C%20clean%20desk%20setup%2C%20natural%20light%2C%20fresh%20modern%20aesthetic%2C%20sage%20and%20cream%20palette%2C%20professional%20photography&width=600&height=400&seq=article-more-2026-v2&orientation=landscape",
    },
    {
      title: "OOPBUY QC Bilder verstehen",
      excerpt: "Lerne Quality Control Bilder richtig zu interpretieren. So erkennst du Produktqualität anhand der QC-Fotos.",
      link: "/oopbuy-sicherheit-datenschutz-guide",
      tag: "QC Guide",
      date: "8. Juli 2026",
      readTime: "9 Min",
      img: "https://readdy.ai/api/search-image?query=Professional%20product%20photography%20setup%20with%20camera%20and%20fashion%20items%20on%20white%20table%2C%20studio%20lighting%2C%20quality%20control%20concept%2C%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20editorial%20photography%20theme&width=600&height=400&seq=article-more-qc-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Kosten & Gebühren erklärt",
      excerpt: "Transparente Übersicht aller OOPBUY Kosten: Agent-Gebühren, Versandkosten und Zoll. Keine versteckten Kosten mehr.",
      link: "/oopbuy-versand-deutschland-guide",
      tag: "Kosten",
      date: "7. Juli 2026",
      readTime: "8 Min",
      img: "https://readdy.ai/api/search-image?query=Clean%20financial%20calculator%20and%20receipt%20on%20white%20marble%20desk%2C%20cost%20calculation%20concept%2C%20soft%20natural%20light%2C%20minimalist%20aesthetic%2C%20warm%20cream%20tones%2C%20professional%20photography%2C%20organized%20composition&width=600&height=400&seq=article-more-costs-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Spreadsheet Tools & Tricks",
      excerpt: "Fortgeschrittene Tipps für Power-User. Optimiere deinen Workflow mit dem OOPBUY Spreadsheet und spare noch mehr Zeit.",
      link: "/einkaufsguide",
      tag: "Pro Tipps",
      date: "6. Juli 2026",
      readTime: "11 Min",
      img: "https://readdy.ai/api/search-image?query=Organized%20desk%20with%20multiple%20screens%20showing%20productivity%20tools%20and%20spreadsheets%2C%20modern%20tech%20workspace%2C%20natural%20light%2C%20clean%20aesthetic%2C%20warm%20sage%20accents%2C%20professional%20photography%2C%20focused%20atmosphere&width=600&height=400&seq=article-more-tools-v2&orientation=landscape",
    },
    {
      title: "OOPBUY Spreadsheet FAQ",
      excerpt: "Die meistgestellten Fragen zum OOPBUY Spreadsheet — kompakt beantwortet. Perfekt für schnelle Antworten.",
      link: "/oopbuy-spreadsheet-deutsch-erklaert",
      tag: "FAQ",
      date: "5. Juli 2026",
      readTime: "6 Min",
      img: "https://readdy.ai/api/search-image?query=Clean%20question%20mark%20and%20answer%20cards%20on%20white%20table%2C%20FAQ%20concept%2C%20soft%20natural%20light%2C%20minimalist%20aesthetic%2C%20warm%20neutral%20palette%2C%20editorial%20photography%2C%20organized%20composition&width=600&height=400&seq=article-more-faq-v2&orientation=landscape",
    },
  ];

  return (
    <section id="guides" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-file-text-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {t("articles_label")}
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            {t("articles_title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
            Hochwertige, SEO-optimierte Inhalte rund um das OOPBUY Spreadsheet — komplett auf Deutsch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-8">
          <div className="md:col-span-1 md:row-span-2 flex flex-col gap-4">
            <Link
              to={featuredArticles[0].link}
              className="flex-1 bg-background-50 rounded-xl p-5 md:p-6 border border-foreground-100/30 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="text-xs text-foreground-500 mb-1">{featuredArticles[0].date}</div>
              <div className="inline-block px-2 py-0.5 bg-primary-100 text-primary-700 rounded text-[10px] font-semibold mb-3">
                {featuredArticles[0].tag}
              </div>
              <div className="text-2xl text-foreground-300 mb-3">
                <i className="ri-double-quotes-l w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {featuredArticles[0].title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                {featuredArticles[0].excerpt}
              </p>
              <span className="inline-block mt-3 text-xs text-primary-600 font-medium group-hover:translate-x-1 transition-transform whitespace-nowrap">
                {t("article_read_more")} →
              </span>
            </Link>

            <Link
              to={featuredArticles[1].link}
              className="flex-1 bg-background-50 rounded-xl p-5 md:p-6 border border-foreground-100/30 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="text-xs text-foreground-500 mb-1">{featuredArticles[1].date}</div>
              <div className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 rounded text-[10px] font-semibold mb-3">
                {featuredArticles[1].tag}
              </div>
              <div className="text-2xl text-foreground-300 mb-3">
                <i className="ri-double-quotes-l w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {featuredArticles[1].title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                {featuredArticles[1].excerpt}
              </p>
              <span className="inline-block mt-3 text-xs text-primary-600 font-medium group-hover:translate-x-1 transition-transform whitespace-nowrap">
                {t("article_read_more")} →
              </span>
            </Link>
          </div>

          <div className="md:col-span-1">
            <Link
              to={featuredArticles[0].link}
              className="block relative rounded-xl overflow-hidden h-full min-h-[320px] group cursor-pointer"
            >
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: `url(${featuredArticles[0].img})`,
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 p-5 md:p-6">
                <div className="text-xs text-white/70 mb-1">{featuredArticles[0].date}</div>
                <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-1 group-hover:text-primary-300 transition-colors">
                  {featuredArticles[0].title}
                </h3>
                <span className="text-xs text-white/60 whitespace-nowrap">
                  {featuredArticles[0].readTime} {t("article_read")}
                </span>
              </div>
            </Link>
          </div>

          <div className="md:col-span-1 flex flex-col gap-4">
            <Link
              to={featuredArticles[1].link}
              className="relative rounded-xl overflow-hidden flex-[2] group cursor-pointer min-h-[180px]"
            >
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: `url(${featuredArticles[1].img})`,
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 p-4 md:p-5">
                <div className="text-xs text-white/70 mb-1">{featuredArticles[1].date}</div>
                <h3 className="text-base font-heading font-semibold text-white group-hover:text-primary-300 transition-colors">
                  {featuredArticles[1].title}
                </h3>
                <p className="text-xs text-white/70 mt-1 line-clamp-2">{featuredArticles[1].excerpt}</p>
                <span className="text-xs text-white/60 mt-1 inline-block whitespace-nowrap">
                  {t("article_read_more")} →
                </span>
              </div>
            </Link>

            <Link
              to={featuredArticles[2].link}
              className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-foreground-100/30 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-footprint-line text-accent-600 text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                    {featuredArticles[2].title}
                  </h3>
                  <p className="text-xs text-foreground-600 line-clamp-2">{featuredArticles[2].excerpt}</p>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {moreArticles.map((article) => (
            <Link
              key={article.title}
              to={article.link}
              className="bg-background-50 rounded-xl overflow-hidden border border-foreground-100/30 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.img}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 inline-block px-2 py-0.5 bg-primary-500/90 text-white rounded text-[10px] font-semibold">
                  {article.tag}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span>{article.readTime} lesen</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <span className="text-xs text-primary-600 font-medium group-hover:translate-x-1 transition-transform inline-block whitespace-nowrap">
                  {t("article_read_more")} →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}